import type { ControllerRenderProps, FieldValues, Path } from "react-hook-form";
import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/base/form/hook-form";
import { Input, type InputBaseProps } from "@/components/base/input/input";

export type FormTextFieldProps<TFieldValues extends FieldValues = FieldValues> =
  {
    field: ControllerRenderProps<TFieldValues, Path<TFieldValues>>;
    label?: string;
    labelClasses?: string;
    inputClasses?: string;
    description?: string;
    className?: string;
    "aria-label"?: string;
  } & Omit<InputBaseProps, "aria-label">;

export const FormTextField = <TFieldValues extends FieldValues = FieldValues>({
  label,
  labelClasses,
  description,
  isRequired,
  field,
  className,
  inputClasses,
  "aria-label": ariaLabel,
  ...props
}: FormTextFieldProps<TFieldValues>) => {
  return (
    <FormItem className={className}>
      <FormLabel className={labelClasses} required={isRequired}>
        {label}
      </FormLabel>
      <FormControl>
        <Input
          {...props}
          {...field}
          aria-label={ariaLabel ?? label}
          className={inputClasses}
          isRequired={isRequired}
        />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  );
};

FormTextField.displayName = "FormTextField";
